import { useEffect, useState } from 'react';

export type LiveData<T> = {
  data: T | null;
  loading: boolean;
  error: Error | null;
};

export function useLiveData<T>(loader: () => Promise<T>, deps: ReadonlyArray<unknown> = []): LiveData<T> {
  const [state, setState] = useState<LiveData<T>>({ data: null, loading: true, error: null });

  useEffect(() => {
    let cancelled = false;
    setState({ data: null, loading: true, error: null });
    loader()
      .then((data) => {
        if (!cancelled) setState({ data, loading: false, error: null });
      })
      .catch((error: unknown) => {
        if (!cancelled) {
          setState({
            data: null,
            loading: false,
            error: error instanceof Error ? error : new Error(String(error)),
          });
        }
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return state;
}
